export default __webpack_public_path__ + "static/home-page-collage-730cd9961d2970d03966afc02ccf5eac.webp";